module.exports = __webpack_public_path__ + "static/homeadvisor-ea9d43137b810921dadbd558b208cd35.png";